if (!customElements.get('product-card')) {
  customElements.define('product-card', class ProductCard extends BaseElement
  {
    // Markets whose per-variant straw counts are tracked by the
    // `donor.market_stock` metafield. When the customer's selected treatment
    // country is in this set, MOT pills on the card are hidden when the
    // per-variant count is 0 and otherwise carry a small count suffix.
    // Australia is additionally gated per state (handled by marketStockKey).
    static GATED_TREATMENT_COUNTRIES = ['gb'];

    constructor ()
    {
      super();

      this.visibility = this.querySelector('product-visibility');
      this.favourite = this.querySelector('product-favourite');
      this.initEvents();
      this.checkNew();
      this.refreshAvailability();
    }

    initEvents ()
    {
      // The AU state changing also re-gates the MOT pills and the badge.
      this.onBroadcast('treatment_au_state_change', () => this.refreshAvailability());

      this.onBroadcast('treatment_country', () => this.refreshAvailability());

      this.onBroadcast('seen_donors', data => {
        const badge = this.querySelector('.product-card-badge.badge-new');

        if (!badge || !app.customer.data) {
          return;
        }

        // let show = true;
        //
        // if (app.customer.data.second_logged_at && this.dataset.productPublishedAt) {
        //   show = moment(app.customer.data.second_logged_at).isBefore(moment(this.dataset.productPublishedAt));
        // } else {
        //   show = false;
        // }
        //
        // data.forEach(row => {
        //   if (row.donor_shopify_id == this.dataset.productCardId) {
        //     show = false;
        //   }
        // });
        //
        // if (show) {
        //   badge.classList.add('show');
        // } else {
        //   badge.classList.remove('show');
        // }
      });
    }

    /**
     * Apply the per-variant `donor.market_stock` metafield to the card's MOT
     * straw pills: when the treatment country is one of the gated markets
     * and a pill carries a `data-market-stock` payload with a zero count,
     * the pill is hidden. Pills without metafield data, or pages where the
     * treatment country isn't gated, are restored to visible.
     */
    applyMarketStockToStrawPills ()
    {
      const key = app.treatmentCountry
        && app.treatmentCountry.marketStockKey(ProductCard.GATED_TREATMENT_COUNTRIES);

      // Straw-set countries (e.g. AU = sets of 6) need at least one whole set
      // in stock for a pill to count as available; everywhere else the
      // minimum is simply 1. Constant across the loop — resolve once.
      const minimum = window.app && window.app.strawSets
        ? window.app.strawSets.sizeForSelection()
        : 1;

      this.querySelectorAll('.product-card-straw').forEach(pill => {
        const raw = pill.dataset.marketStock;

        if (!key || !raw) {
          pill.hidden = false;
          return;
        }

        let parsed;
        try {
          parsed = JSON.parse(raw);
        } catch (e) {
          pill.hidden = false;
          return;
        }

        // Missing key = zero compliant straws for this gated market (the
        // backend omits zero-count markets) — fail closed. A wholly missing
        // metafield (handled above) stays visible: unsynced or Fairfax
        // donors are gated by tags instead.
        const count = typeof parsed[key] === 'number' ? parsed[key] : 0;

        pill.hidden = count < minimum;
      });
    }

    refreshAvailability ()
    {
      this.applyMarketStockToStrawPills();
      this.updateStockBadge();
    }

    /**
     * Card is market-sold-out when the selection is stock-gated and no straw
     * pill is left visible after applyMarketStockToStrawPills() — e.g. every
     * variant below one whole set for AU. Without this the card kept its
     * server-rendered "in stock" badge while showing zero pills.
     */
    isMarketSoldOut ()
    {
      const key = app.treatmentCountry
        && app.treatmentCountry.marketStockKey(ProductCard.GATED_TREATMENT_COUNTRIES);

      if (!key) {
        return false;
      }

      const pills = this.querySelectorAll('.product-card-straw');

      if (!pills.length) {
        return false;
      }

      let anyVisible = false;

      pills.forEach(pill => {
        if (!pill.hidden) {
          anyVisible = true;
        }
      });

      return !anyVisible;
    }

    /**
     * ONE resolver for the stock badge so the states can't stack classes on
     * each other (the old quota swap and a market swap would each re-add
     * classes the other had removed). Precedence: quota-exceeded (logged-in
     * only — quota data stays customer-scoped) > market sold-out > the
     * server-rendered state.
     */
    updateStockBadge ()
    {
      const selection = app.treatmentCountry && app.treatmentCountry.getSelection
        ? app.treatmentCountry.getSelection()
        : { country: null };

      this.querySelectorAll('.product-card-stock').forEach(stockDiv => {
        if (typeof stockDiv.dataset.originalClass === 'undefined') {
          stockDiv.dataset.originalClass = stockDiv.classList.contains('product-card-stock-has-in')
            ? 'product-card-stock-has-in'
            : 'product-card-stock-has-out';
        }

        let state = stockDiv.dataset.originalClass;

        if (this.isMarketSoldOut()) {
          state = 'product-card-stock-has-out';
        }

        const quotaExceededDiv = stockDiv.querySelector('.product-card-stock-quota');

        if (theme.customer && selection.country && quotaExceededDiv) {
          const quotaJson = JSON.parse(quotaExceededDiv.dataset.quotaExceeded);

          if (quotaJson[selection.country.toLowerCase()]) {
            state = 'product-card-stock-has-quota';
            quotaExceededDiv.dataset.tippyTitle = quotaExceededDiv.dataset.quotaTip;

            window.app.initTippy();
          }
        }

        stockDiv.classList.remove(
          'product-card-stock-has-in',
          'product-card-stock-has-out',
          'product-card-stock-has-quota'
        );
        stockDiv.classList.add(state);
      });
    }

    checkNew ()
    {
      const badge = this.querySelector('.product-card-badge.badge-new');

      if (!badge) {
        return;
      }

      let showBadge = true;

      if (this.dataset.newDonorBadgeUntil) {
        const showBadgeUntil = moment(this.dataset.newDonorBadgeUntil);
        showBadge = moment().isBefore(showBadgeUntil);
      } else {
        const publishedAt = moment(this.dataset.productPublishedAt);
        showBadge = moment().subtract(3, 'months').isBefore(publishedAt);
      }

      if (showBadge) {
        badge.classList.add('show');
      }
    }
  });
}